import React, {useEffect} from "react";
import CheckBoxPrivateComment from "@dropDesk/presentation/components/check_box/check_box_private_comment";
import {observer} from "mobx-react";

const PrivateComment = observer((
    {
        messageIsPrivate,
        handleAllChanges,
        canSendMessage,
        forcePrivateComment
    }: {
        messageIsPrivate: boolean
        canSendMessage: boolean
        forcePrivateComment: boolean
        handleAllChanges: (event: { target: { name: string; value: any; checked: any; type: string } }) => void,
    }) => {
    useEffect(() => {
        if(forcePrivateComment){
            handleAllChanges({
                target: {
                    name: 'isPrivate',
                    value: true,
                    checked: true,
                    type: 'switch'
                }
            });
        }
    }, [forcePrivateComment]);


    return (

        <CheckBoxPrivateComment
            checked={messageIsPrivate}
            disabled={!canSendMessage || forcePrivateComment}
            forcePrivateComment={forcePrivateComment}
            onChange={(event) => {
                handleAllChanges({
                    target: {
                        name: 'isPrivate',
                        value: event.target.value,
                        checked: event.target.checked,
                        type: 'switch'
                    }
                });
            }}
        />
    )
});
export default PrivateComment;
